import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// ThemeProvider is in App.tsx - no duplicate here
createRoot(document.getElementById("root")!).render(<App />);
